const n = value => Number(value || 0);
const money = value => Math.round((value + Number.EPSILON) * 100) / 100;
export function grnDetailTotals(grn = {}) {
  const items = grn.items || [];
  const sum = fn => money(items.reduce((total, item) => total + fn(item), 0));
  const quantity = key => Number(items.reduce((total, item) => total + n(item[key]), 0).toFixed(3));
  const received = quantity('quantityReceived');
  const accepted = quantity('quantityAccepted');
  const rejected = quantity('quantityRejected');
  const basic = sum(item => n(item.quantityAccepted) * n(item.unitCost));
  const cd = sum(item => n(item.cashDiscountAmount));
  const td = sum(item => n(item.tradeDiscountAmount));
  const spcd = sum(item => n(item.specialDiscountAmount));
  const discount = sum(item => n(item.totalDiscountAmount));
  const cgst = sum(item => n(item.cgstAmount));
  const sgst = sum(item => n(item.sgstAmount));
  const igst = sum(item => n(item.igstAmount));
  const goodsTax = money(cgst + sgst + igst);
  const goodsTotal = sum(item => n(item.lineTotal));
  const taxable = money(goodsTotal - goodsTax);
  const freight = n(grn.freightAmount), freightTax = n(grn.freightTaxAmount);
  const roundOff = n(grn.roundOffAmount);
  const payable = grn.totalAmount == null ? money(goodsTotal + freight + freightTax + roundOff) : n(grn.totalAmount);
  const beforeRoundOff = money(payable - roundOff);
  const stockCost = sum(item => n(item.quantityAccepted) * n(item.landedUnitCost ?? item.discountedUnitCost ?? item.unitCost));
  const bands = new Map();
  for (const item of items) {
    const rate = n(item.taxRate);
    const band = bands.get(rate) || {rate, taxable:0, cgst:0, sgst:0, igst:0};
    band.cgst += n(item.cgstAmount); band.sgst += n(item.sgstAmount); band.igst += n(item.igstAmount);
    band.taxable += n(item.lineTotal) - n(item.cgstAmount) - n(item.sgstAmount) - n(item.igstAmount);
    bands.set(rate, band);
  }
  return {received,accepted,rejected,basic,cd,td,spcd,discount,cgst,sgst,igst,goodsTax,goodsTotal,taxable,
    freight,freightTax,totalGst:money(goodsTax+freightTax),roundOff,payable,beforeRoundOff,stockCost,
    taxBands:[...bands.values()].sort((a,b)=>a.rate-b.rate)};
}
